module.exports = __webpack_public_path__ + "media/images/emoticons/bar-e1bebd57c867a09ff1cf35ce71c991c8.gif";